import { FormControl, Grid, TextField } from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import __ from "lodash";

import { ComboSelect, FormDialog }from "../../../../controls";
import { useAddNote, useNotes, useUpdateNote } from '../../../../services/notes';
import Validator from "../../validators/TripLegDiversionValidator";
import { MovementTimes } from "../../../Trips/components/TripListDialogs/MovementsTooltip";
import AirportsLookup from '../../../Airports/components/AirportsLookup';

const TripLegDiversionDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    tripLegUuid: null,
    noteType: "TRIP_LEG:FLIGHT_DIVERSION",
    noteUuid: null,
    title: 'Flight Diversion',
    tripData: null
  });

  const DisplayForm = () => {
    const extraKeys = [dialogState.noteUuid||'']
    const note = useNotes({queryClient, extraKeys});
    const handleAddNote = useAddNote();
    const handleUpdateNote = useUpdateNote();

    if ((note && Array.isArray(note.data) && note.data.length > 0 ) || !dialogState.noteUuid) {
      return (
        <FormDialog
          title={dialogState.title}
          message=""
          open={dialogState.showDialog}
          record={!dialogState.noteUuid ? {primaryObjectUuid: dialogState.tripLegUuid, noteType: dialogState.noteType, divertedTo:'', diversionCategory:''} : {...note.data[0], ...note.data[0].noteData||{}}}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              if (dialogState.noteUuid) {
                const noteData = {...state.record.noteData, ...__.pick(state.record, ['diversionCategory', 'divertedToAirport'])}
                const record = {...state.record, noteData};
                handleUpdateNote.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Diversion", "An unexpected error has occurred while saving the note.");
                  }
                });
              } else {
                const noteData = {...__.pick(state.record, ['diversionCategory', 'divertedToAirport']), ...__.pick(dialogState.tripData, ['originAirportCode', 'destinationAirportCode'])}
                const record = {...state.record, noteData};
                handleAddNote.mutate({
                  record,
                  extraKeys,
                  resolve: () => {
                    setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                    if (props.afterSave) {
                      props.afterSave();
                    }
                    if (typeof props.onClose === 'function') {props.onClose()}
                  },
                  reject: (err) => {
                    SystemData.openAlert("Error Saving Diversion", "An unexpected error has occurred while saving the note.");
                  }
                });
              }
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              if (typeof props.onClose === 'function') {props.onClose()}
            }
          }}
        >
          <div style={{display: "inline-block", width: 400}} checkChildren={true}>
            <Grid container checkChildren={true} spacing={3} >{/*style={{width: "calc(100% + 36px"}}*/}
              <Grid item xs={12} checkChildren={true}>
                <MovementTimes classes={classes} data={dialogState.tripData} showScheduled={true}/>
              </Grid>
              <Grid item xs={6} checkChildren={true}>
                <FormControl checkChildren={true} style={{display: "block"}}>
                  <ComboSelect
                    id="diversionCategory"
                    label="Category"
                    group="FLIGHT DIVERSION"
                    subGroup="CATEGORIES"
                    inputLabelProps={{ shrink: true }}
                    fullWidth
                    //style={{marginTop: "1px"}}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} checkChildren={true}>
                <AirportsLookup
                  id="divertedToAirport"
                  label="Diverted To"
                  inputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <TextField
                  id="noteText"
                  label="Diversion Reason"
                  placeholder="Diversion reason"
                  multiline
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </div>
        </FormDialog>
      )
    } else {
      return <></>;
    }
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit, tripLegUuid, noteType, noteUuid, tripData} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, tripLegUuid, noteType, noteUuid, tripData});
    }
    eventBus.bind("TripLegDiversionDialog.open", open);
    return () => {
      eventBus.unbind("TripLegDiversionDialog.open", open);
      queryClient.invalidateQueries("Notes");
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default TripLegDiversionDialog;
